import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errorText } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sessionId })
      .then(async ({ data }) => {
        // consent ticked on the sign-up form before going to Google
        const pre = sessionStorage.getItem("pensive_consent") === "1";
        sessionStorage.removeItem("pensive_consent");
        if (pre && data.consent_needed) {
          // if this fails, the consent screen asks again
          data = (await api.post("/auth/consent", { accept_terms: true, accept_privacy: true }).catch(() => ({ data }))).data;
        }
        setUser(data);
        navigate("/escribir", { replace: true });
      })
      .catch((e) => {
        setError(errorText(e));
        setUser(false);
      });
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen bg-papel flex items-center justify-center px-6" data-testid="auth-callback">
      {error ? (
        <div className="max-w-sm space-y-4">
          <p className="calm-note" data-testid="auth-callback-error">{error}</p>
          <button className="btn-secondary" onClick={() => navigate("/entrar", { replace: true })} data-testid="auth-callback-back">
            Volver a entrar
          </button>
        </div>
      ) : (
        <p className="text-sm text-meta">Abriendo tu diario…</p>
      )}
    </div>
  );
}
